import http from '@/utils/http';

import type { IConditionalRule } from '@home/types/common';

export const fetchConditions = (params: IRecord): IBaseResponse => {
  return http({
    url: '/api/v1/intelligence_pc/cond',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};

/**
 * 获取系统级CRON表达式配置
 * @param body 入参
 * @return 系统CRON表达式配置
 */
export const fetchCRONExpressions = async (
  body: IRecord,
): IBaseResponse<{ get_tag_rule: IConditionalRule[] | null }> => {
  return http({
    url: '/api/v1/intelligence_pc/cond',
    method: 'post',
    data: {
      cron_expressions: {
        target: 'get_tag_rule',
        params: {
          key: body?.prefix || '*',
        },
      },
    },
    rawData: true,
  }) as any;
};
